export default function CardsSection() {
  return (
    <section id="cards" className="relative py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
              精选推荐
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
              编辑团队每日精选，为你推荐值得一看的好内容
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            <div className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 transition-all duration-300 hover:-translate-y-1 lg:col-span-2 lg:row-span-2">
              <div className="relative w-full aspect-[16/10] lg:aspect-auto lg:h-full overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20dramatic%20urban%20night%20scene%20with%20a%20couple%20standing%20on%20a%20rooftop%20overlooking%20city%20lights%2C%20romantic%20atmosphere%2C%20warm%20golden%20and%20amber%20city%20glow%2C%20cinematic%20lighting%2C%20emotional%20moment%2C%20Chinese%20drama%20poster%20aesthetic%2C%20clean%20composition&width=1000&height=700&seq=douhua-cards-1&orientation=squarish"
                  alt="繁花似锦 - 都市情感大剧推荐"
                  className="w-full h-full object-cover lg:absolute lg:inset-0 group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                  <span className="inline-block px-2.5 py-1 rounded-full text-xs font-medium bg-primary-500 text-background-50 mb-2 whitespace-nowrap">编辑力荐</span>
                  <h3 className="text-lg md:text-xl font-semibold text-background-50 mb-1">繁花似锦</h3>
                  <p className="text-sm text-background-200/80 line-clamp-2">一部关于都市男女在繁华中寻找真爱的情感大戏，全网播放量突破5亿的现象级热剧。</p>
                </div>
              </div>
            </div>

            <div className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 transition-all duration-300 hover:-translate-y-1">
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20suspenseful%20dark%20alleyway%20at%20night%20with%20a%20single%20streetlamp%2C%20mysterious%20atmosphere%2C%20film%20noir%20style%2C%20detective%20theme%2C%20warm%20amber%20light%20against%20shadows%2C%20cinematic%20composition%2C%20thriller%20vibe&width=640&height=360&seq=douhua-cards-2&orientation=landscape"
                  alt="迷雾追踪 - 悬疑推理剧推荐"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">迷雾追踪</h3>
                <p className="text-xs text-foreground-600 line-clamp-2">樱桃视频年度悬疑力作，烧脑反转让人欲罢不能。</p>
              </div>
            </div>

            <div className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 transition-all duration-300 hover:-translate-y-1">
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20vibrant%20space%20battle%20scene%20with%20colorful%20nebula%20background%2C%20futuristic%20spaceships%2C%20epic%20scale%2C%20warm%20orange%20and%20amber%20energy%20beams%2C%20cinematic%20sci-fi%20aesthetic%2C%20dramatic%20lighting%2C%20movie%20poster%20style&width=640&height=360&seq=douhua-cards-3&orientation=landscape"
                  alt="星际征途 - 科幻电影推荐"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">星际征途</h3>
                <p className="text-xs text-foreground-600 line-clamp-2">蘑菇视频科幻巨制，视觉特效震撼，科幻迷必看。</p>
              </div>
            </div>

            <div className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 transition-all duration-300 hover:-translate-y-1">
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20warm%20family%20dinner%20scene%20with%20three%20generations%20laughing%20around%20a%20table%20full%20of%20Chinese%20dishes%2C%20bright%20natural%20light%2C%20joyful%20atmosphere%2C%20family%20comedy%20aesthetic%2C%20clean%20composition%2C%20warm%20colors&width=640&height=360&seq=douhua-cards-4&orientation=landscape"
                  alt="欢乐一家亲 - 家庭喜剧推荐"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">欢乐一家亲</h3>
                <p className="text-xs text-foreground-600 line-clamp-2">糖豆视频治愈家庭喜剧，三代同堂的温馨笑料不断。</p>
              </div>
            </div>

            <div className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 transition-all duration-300 hover:-translate-y-1">
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20traditional%20Chinese%20kitchen%20with%20steaming%20woks%2C%20fresh%20ingredients%20on%20wooden%20cutting%20boards%2C%20warm%20natural%20light%20from%20window%2C%20authentic%20cooking%20scene%2C%20food%20documentary%20style%2C%20rich%20textures%2C%20earthy%20warm%20colors&width=640&height=360&seq=douhua-cards-5&orientation=landscape"
                  alt="寻味中国 - 美食纪录片推荐"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">寻味中国</h3>
                <p className="text-xs text-foreground-600 line-clamp-2">走遍大江南北探寻地道中华美食，每集都是视觉享受。</p>
              </div>
            </div>

            <div className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 transition-all duration-300 hover:-translate-y-1">
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20beautiful%20ancient%20Chinese%20courtyard%20with%20blooming%20flowers%2C%20traditional%20architecture%2C%20elegant%20figures%20in%20flowing%20robes%2C%20soft%20golden%20afternoon%20light%2C%20romantic%20period%20drama%20aesthetic%2C%20warm%20and%20dreamy%20atmosphere&width=640&height=360&seq=douhua-cards-6&orientation=landscape"
                  alt="桃花依旧 - 古装爱情剧推荐"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">桃花依旧</h3>
                <p className="text-xs text-foreground-600 line-clamp-2">蜜桃视频古装爱情新作，乱世中的唯美虐恋故事。</p>
              </div>
            </div>

            <div className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 transition-all duration-300 hover:-translate-y-1">
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20gritty%20street%20racing%20scene%20with%20sports%20cars%20at%20dusk%2C%20motion%20blur%2C%20neon%20city%20lights%20in%20background%2C%20high%20energy%2C%20cinematic%20action%20photography%2C%20warm%20orange%20and%20amber%20tones%2C%20adrenaline%20fueled%20atmosphere&width=640&height=360&seq=douhua-cards-7&orientation=landscape"
                  alt="狂飙人生 - 动作电影推荐"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">狂飙人生</h3>
                <p className="text-xs text-foreground-600 line-clamp-2">红桃视频燃爆动作片，地下赛车手的逆袭之路。</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}